import React from 'react';
import { observer } from 'mobx-react';

import LoginForm from '../components/auth/LoginForm';

import '../assets/scss/auth.scss';
import AuthStore from '../store/auth/AuthStore';
import OTPForm from '../components/auth/OTPForm';
import Header from '../components/common/Header';

const AuthPage: React.FC = observer(() => {
  return (
    <>
      <Header />
      {AuthStore.stage === 'otp' ? <OTPForm /> : <LoginForm />}
    </>
  );
});

export default AuthPage;